import type { HttpErrorResponse } from '@angular/common/http';

import type { BillingInformation } from '@core/billing-types';
import { createSingleEntityStore, ngrxEvent } from '@core/ngrx-legacy';

import type { BillingInformationUpdatePayload } from './entity.types';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<{}>()(
  'BillingInformationEntity',
  {
    customActions: () => ({
      updateBillingInformation: ngrxEvent<BillingInformationUpdatePayload>(),
      updateBillingInformationSuccess: ngrxEvent<BillingInformation>(),
      updateBillingInformationFailed: ngrxEvent<HttpErrorResponse>(),
    }),
  },
);

export {
  actions as BillingInformationEntityActions,
  selectors as BillingInformationEntitySelectors,
  reducer as BillingInformationEntityReducer,
  namespace as BillingInformationEntityNamespace,
};
